// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__IeQbu","tips":"styles_tips__Nq8EZ"};